// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"newMembersGraph_placeholder__16VQn"};